export const enum RegExPattern {
  CONFIRMATION_NUMBER_PATTERN = '^[a-zA-Z0-9]+$',
  NUMBER_PATTERN = '^[0-9]+$',
  NAME_PATTERN = "^[a-zA-Z' ]+$",
  FLIGHT_NUMBER_PATTERN = '^[0-9]*$',
  AIRPORT_NAME_PATTERN = '^[a-zA-Z]+$'
}

export const enum HEADER_FEATURES {
  CHECK_IN = 'CHECK_IN',
  COMMON = 'COMMON',
  SEARCH_FLIGHTS = 'SEARCH_FLIGHTS',
  MY_TRIPS = 'MY_TRIPS',
  MULTI_FACTOR_AUTHENTICATION_PAGE = 'MULTI_FACTOR_AUTHENTICATION_PAGE',
  BOOKING_WIDGETS = 'BOOKING_WIDGETS'
}

export enum CATALOG_API_HTTP_HEADERS {
  APP_ID = 'DC',
  CONTENT_TYPE = 'application/json; charset=UTF-8',
  CHANNEL_ID = 'DCOM'
}

export const enum EndpointKeys {
  CHECK_IN_STATIC_URL = 'CHECK_IN_STATIC_URL',
  APP_SESS_CUSTOMER_GETPREFILL_URL = 'APP_SESS_CUSTOMER_GETPREFILL_URL',
  APP_SESS_CUSTOMER_UPDATE_PREFILL_URL = 'APP_SESS_CUSTOMER_UPDATE_PREFILL_URL',
  APP_SESS_CUSTOMER_EDP_DATA_SLIM_NAV_URL = 'APP_SESS_CUSTOMER_EDP_DATA_SLIM_NAV_URL',
  APP_SESS_CUSTOMER_EDP_RETRIEVE_SLIM_NAV_URL = 'APP_SESS_CUSTOMER_EDP_RETRIEVE_SLIM_NAV_URL',
  GET_CLOSEST_DELTA_AIRPORT_CODE = 'GET_CLOSEST_DELTA_AIRPORT_CODE',
  SEARCH_FLIGHTS_AEM_URL = 'SEARCH_FLIGHTS_AEM_URL',
  SEARCH_FLIGHTS_CATALOG_API_URL = 'SEARCH_FLIGHTS_CATALOG_API_URL',
  GET_PREDICTIVE_CITIES_URL = 'GET_PREDICTIVE_CITIES_URL',
  APP_PROFILE_GRAPHQL_ENDPOINT = 'APP_PROFILE_GRAPHQL_ENDPOINT',
  EDOCS_DEFAULT_LOOKUP = 'EDOCS_DEFAULT_LOOKUP',
  APP_GET_DEFAULTS_AND_LOOKUPS = 'APP_GET_DEFAULTS_AND_LOOKUPS',
  FIND_PNR = 'FIND_PNR',
  CHECK_IN_ACTION = 'CHECK_IN_ACTION',
  MY_TRIPS_STATIC = 'MY_TRIPS_STATIC',
  RETRIEVE_SEARCH_MC = 'RETRIEVE_SEARCH_MC'
}

export const enum CommonConstants {
  TIMEOUT = 120000
}

export const enum ScreenSize {
  SIZE_991 = 991
}

export enum NavigationType {
  book = 'book',
  checkIn = 'check_in',
  flightStatus = 'flightstatus',
  myTrips = 'my_trips',
  secondary = 'secondary'
}

export enum BookingCategory {
  flights = 'flights',
  stays = 'stays',
  cars = 'cars',
  vacations = 'vacations',
  cruises = 'cruises'
}

export enum IDP_APP {
  MY_TRIPS = 'MY_TRIPS'
}

export const NO_TOKEN = 'No Token Obtained';
export const MULTI_FACTOR_AUTHENTICATION_PAGE =
  'MULTI_FACTOR_AUTHENTICATION_PAGE';
